var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarningError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_warning_errorsubmission",
    d: "M31.2,6.819,3.96,53.952C2.237,56.9,4.529,60.5,8.128,60.5h54.5A4.454,4.454,0,0,0,66.8,53.952L39.54,6.819A4.907,4.907,0,0,0,31.2,6.819Zm6.876,19.556-.554,17.792H33.218l-.554-17.792ZM35.371,53.85a2.694,2.694,0,1,1,2.938-2.683A2.792,2.792,0,0,1,35.371,53.85Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#dc1c4c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningError);
export default __webpack_public_path__ + "static/media/icon_warning_error.f130ce7d0bd5d419e438feccaf2cd497.svg";
export { ForwardRef as ReactComponent };